<!-- 入库单据数字化维护 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page"
      :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      infoCardData: [], // 卡片数据
      option: {
        ...this.$store.state.publicOption,
        column: [
          {
            label: '物资名称',
            prop: 'cargoName',
            search: true, // 查询是否显示
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?cargoName={{key}}',
            props: {
              label: 'cargoName',
              value: 'id'
            },
          },
          {
            label: '库区',
            prop: 'stockId',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            dataType:'number',
            dicUrl: '/api/produce/location/select/distinct/pycode?stockName={{key}}',
            props: {
              label: 'stockName',
              value: 'id'
            },
          },
          {
            label: '合同名称',
            prop: 'contractName',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'select',
            remote: true,
            dicUrl: '/api/produce/transport-contract/select/distinct/pycode?contractName={{key}}',
            props: {
              label: 'contractName',
              value: 'id'
            },
          },
          {
            label: '入库时间',
            prop: 'createTime',
            overHidden: true, // 表格超出隐藏
            width: 150,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: '剩余容量',
            prop: 'stockRemain',
            overHidden: true, // 表格超出隐藏
            width: 150,
            type: 'number',
            precision: 0,
            min:1,
            max: 99999,
          },
          {
            label: '客户',
            prop: 'custNo',
            type: 'select',
            dicUrl: '/api/produce/blade-dept/select/distinct/select',
            search: true, // 查询是否显示
            props: {
              label: 'deptName',
              value: 'id'
            },
          },
          {
            label: '车次',
            prop: 'trainNumber',
          },
          {
            label: '操作人',
            prop: 'updateName',
            width: 150,
            overHidden: true, // 表格超出隐藏
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  }
}
</script>
<style scoped lang="scss">
p {
  margin: 0;
}
</style>
